var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"disabled":!_vm.tooltip || _vm.disabled,"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('span',_vm._g({staticStyle:{"display":"flex","justify-content":"center","align-items":"center"}},on),[_vm._t("default",[_vm._v("tooltip")])],2)]}}],null,true)},[_c('span',[_vm._v(" "+_vm._s(_vm.tooltip)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }